<template>
  <div class="py-6 max-w-6xl mx-auto">
    <base-headline v-if="row.title && row.title.length" class="mb-4 text-xl">{{ row.title }}</base-headline>

    <div v-if="vimeo" v-html="vimeo.html" :style="vimeoRatio" class="w-full relative"></div>
    <div v-else-if="qq" id="qqplayer" ref="qqplayer" style="padding-bottom:56%" class="w-full relative"></div>

    <figcaption v-if="row.caption" v-html="row.caption" class="text-xs mt-2 mb-6"></figcaption>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import axios from 'axios'
import { loadJS } from '@/utils'

export default {
  name: 'BaseArticleVideoRow',
  props: {
    row: Object
  },
  data () {
    return {
      vimeo: null,
      qq: null,
      qqplayer: null
    }
  },
  computed: {
    vimeoRatio () {
      if (!this.vimeo) return
      return {
        paddingBottom: `${(this.vimeo.height / this.vimeo.width) * 100}%`
      }
    }
  },
  methods: {
    vimeoEmbed (id) {
      axios.get(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}`).then(({ data }) => {
        this.vimeo = data
      })
    }
  },
  created () {
    const { id_qq, id_vimeo } = this.row
    if (id_vimeo) {
      this.vimeoEmbed(id_vimeo)
    }
    if (id_qq) {
      // example embed code from QQ
      // <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=b0814u2sqll" allowFullScreen="true"></iframe>
      this.qq = id_qq
    }
  },
  mounted () {
    this.$store.commit('HAS_MEDIA', true)

    window.addEventListener('TxPlayerJSBrageReady', () => {
      console.log('ready')
    })

    if (this.qq) {
      loadJS('https://vm.gtimg.cn/tencentvideo/txp/js/txplayer.js').then(
        () => {
          console.log('loaded')
          /* eslint-disable */
          this.qqplayer = this.$nextTick(() => {
            new Txplayer({
              containerId: 'qqplayer',
              vid: this.qq,
              width: '100%',
              height: '100%'
            });
          })
          /* eslint-enable */
        }
      )
    }
  },
  beforeDestroy () {
    this.$store.commit('HAS_MEDIA', false)
  }
}
</script>

<style lang="stylus">
  .w-full iframe, .w-full .txp_player
    width: 100%
    height: 100%
    position: absolute
    top: 0
    left: 0

  .txp_player
    padding-bottom: 56%

  .txp_contextmenu
    display: none
</style>
